import { disableScrolling, enableScrolling } from '../../../vendorjs/helpers/disableScrolling';

const { Alpine } = window;
Alpine.store('megaLayer', {
  visible: false,
  toggle() {
    if (this.visible) this.close();
    else this.open();
  },
  open() {
    disableScrolling();
    this.visible = true;
  },
  close() {
    enableScrolling();
    this.visible = false;
  },
});
